import { gql } from '@apollo/client';
const GET_ORDER_MODEL_VARIANTS = gql `
  query GetOrderModelVariants($id: ID!) {
    node(id: $id) {
      ... on OrderModelNode {
        id
        colors {
          edges {
            node {
              id
              name
            }
          }
        }
        sizes {
          edges {
            node {
              id
              name
            }
          }
        }
        variants {
          edges {
            node {
              id
              quantity
              orderModelSize {
                id
                name
              }
              orderModelColor {
                id
                name
              }
            }
          }
        }
        modelSpecificationNode {
          id
          fancyName
          folder {
            id
            name
          }
        }
        modelReady
      }
    }
  }
`;
export default GET_ORDER_MODEL_VARIANTS;
